// polyfill
import 'intersection-observer'
import Vue from 'vue'

export default {
  exposure: {
    bind(el, binding) {
      if (!IntersectionObserver) return

      let rootMargin = '0px 0px 0px 0px'
      if (binding?.value?.getMargin) {
        try {
          rootMargin = binding.value.getMargin()
        } catch (error) {
          console.log(error)
        }
      }

      const io = new IntersectionObserver(
        items => {
          items.forEach(item => {
            if (item.isIntersecting) {
              // binding?.value?.callback && binding.value.callback()
              el.timer = setTimeout(() => {
                // 上报统计数据
                binding?.value?.callback && binding.value.callback()
                item.target.__reported = true
                // 停止观察
                // io.disconnect()
              }, 500)
            } else {
              el.timer && clearTimeout(el.timer)
            }
          })
        },
        {
          threshold: binding?.value?.threshold || 0.5,
          rootMargin
        }
      )
      io.observe(el)
      el._vueExposureObserver = io
    },
    componentUpdated(el, binding) {
      if (binding.value.id !== binding.oldValue.id) {
        if (el._vueExposureObserver) {
          el._vueExposureObserver.disconnect()
          delete el._vueExposureObserver
        }
        if (el.timer) {
          clearTimeout(el.timer)
          delete el.timer
        }
        const observer = el._vueExposureObserver
        if (observer) {
          observer.disconnect()
        }
        Vue.nextTick(() => {
          Vue.directive('exposure').bind(el, binding)
        })
      }
    }
  }
}
